/**
 * AppError Interface
 * Oeps, er ging iets fout
 */

export type ErrorType = 
  | 'database' 
  | 'database_init'
  | 'database_query'
  | 'database_connection'
  | 'database_corrupted'
  | 'database_not_found'
  | 'permission' 
  | 'not_found' 
  | 'camera'
  | 'camera_permission'
  | 'camera_unavailable'
  | 'network' 
  | 'unknown';

export interface AppError extends Error {
  type: ErrorType;
  message: string;
  recoverable: boolean;
  retryAction?: () => void;
  originalError?: Error;
}

// Hulpfunctie om fouten te maken (expres dan he)
export const maakApplicatieFout = (
  type: ErrorType,
  message: string,
  recoverable: boolean = true,
  retryAction?: () => void,
  originalError?: Error
): AppError => {
  const error = new Error(message) as AppError;
  error.type = type;
  error.recoverable = recoverable;
  error.retryAction = retryAction;
  error.originalError = originalError;
  return error;
};

// Wat is er precies misgegaan in de database?
export const bepaalDatabaseFoutType = (error: any): ErrorType => {
  const errorMessage = error?.message?.toLowerCase() || '';
  
  if (errorMessage.includes('not found') || errorMessage.includes('no such table')) {
    return 'database_not_found';
  }
  
  if (errorMessage.includes('corrupt') || errorMessage.includes('malformed')) {
    return 'database_corrupted';
  }
  
  if (errorMessage.includes('connection') || errorMessage.includes('open')) {
    return 'database_connection';
  }
  
  if (errorMessage.includes('query') || errorMessage.includes('sql')) {
    return 'database_query';
  }
  
  return 'database';
};

// Check of het onze eigen fout is
export const isApplicatieFout = (error: any): error is AppError => {
  return error && typeof error === 'object' && 'type' in error;
};
